import React from "react";
import { Link } from "react-router-dom";
import estilo from "./styles/Tarjetas.module.css";

function Tarjetas({ lista }) {
  if (lista.nombre.length >= 24) {
    // var resultado = lista.nombre.substring(0, 22) + "...";
    var resultado = lista.nombre.split(" ").slice(0, 5).join(" ") + "...";
  } else if (lista.nombre.length < 24) {
    var resultado = lista.nombre.split(" ").slice(0, 5).join(" ");
  }

  var generos = lista.generos.map((e) => e.genero);

  return (
    <div className={estilo.animes}>
      <Link to={"/" + lista.uid}>
        <div className={estilo.tarjetas}>
          <img src={lista.portada} alt={lista.nombre} />
          <h4>{lista.año}</h4>
        </div>
        <div className={estilo.lista}>
          <p>{resultado}</p>
          <div className={estilo.animes_contenido}>
            {lista.completado ? (
              <p>
                <b>Estado: </b>Finalizado
              </p>
            ) : (
              <p>
                <b>Estado: </b>Emisión
              </p>
            )}
            <p>
              <b>Capítulos: </b>
              {lista.cantidad_capitulos}
            </p>
            <p>
              <b>Generos: </b>
              {generos
                .slice(0, -1)
                .join(", ")
                .concat(" y " + generos.slice(-1) + ".")}
            </p>
            <p>
              <b>Sinopsis: </b>
              {lista.sinopsis.split(" ").slice(0, 15).join(" ") + "..."}
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default Tarjetas;
